const Resources = {

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms',
            href:   '/building-rooms',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms - Mass edit rooms',
            href:   '/building-rooms-mass-edit',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Custom Room Descriptions',
            href:   '/custom-room-descriptions',
            arrow:  "",
        },
    ],

    table_headers: [
        { 
            text:   'Description',
            align:  'start', 
            value:  'description',
            type:   'link'
        },
        { 
            text:   'Building',
            value:  'building'
        },
        { 
            text:   'Level',
            value:  'level'
        },
        { 
            text:   'Area',
            value:  'area'
        },
    ],

}

export default Resources;